import {JsonObject, JsonProperty} from 'json2typescript';
import {SearchStrategy} from './searchStrategy';

@JsonObject('RespondentIdentification')
export class RespondentIdentification {
    @JsonProperty('search_strategy',SearchStrategy,true)
    search_strategy:SearchStrategy = null;
}
